import { handleActions } from 'redux-actions';

import loadingStatuses from '@constants/loadingStatuses';
import { BillingPublisherAddressType, BillingPublisherType } from '@ts/billing-publisher.types';
import {
  setPublisherBillingAddressData,
  setPublisherBillingAddressLs,
  setPublisherBillingData,
  setPublisherBillingLs,
} from '@redux/actions/billing-publisher.actions';

export type PublisherBillingsStateType = {
  billingDetails: {
    loadingStatus: string;
    data: BillingPublisherType;
  };
  billingAddress: {
    loadingStatus: string;
    data: BillingPublisherAddressType;
  };
};

const initialState: PublisherBillingsStateType = {
  billingDetails: {
    loadingStatus: loadingStatuses.PENDING,
    data: {
      id: 0,
      availableFunds: 0,
      pendingFunds: 0,
      inWithdrawalFunds: 0,
      paymentSettingsList: [],
      ownerEmail: '',
      // 0 = not loaded yet; consumers fall back to their own default.
      websiteLimit: 0,
    },
  },
  billingAddress: {
    loadingStatus: loadingStatuses.PENDING,
    data: {
      addressId: 0,
      companyName: '',
      firstLine: '',
      secondLine: '',
      city: '',
      zipCode: '',
      state: '',
      country: '',
      contactEmail: '',
      contactName: '',
      tax: '',
      dateOfBirth: 0,
      payoutProfileType: 0,
      foreignTin: '',
      usTin: '',
      countryOfTaxResidence: '',
      countryOfCitizenship: '',
      countryOfIncorporation: '',
      entityClassification: 0,
    },
  },
};

export default handleActions(
  {
    [setPublisherBillingLs]: (state, { payload }) => ({
      ...state,
      billingDetails: {
        ...state.billingDetails,
        loadingStatus: payload,
      },
    }),
    [setPublisherBillingData]: (state, { payload }) => ({
      ...state,
      billingDetails: {
        ...state.billingDetails,
        data: payload,
      },
    }),
    [setPublisherBillingAddressLs]: (state, { payload }) => ({
      ...state,
      billingAddress: {
        ...state.billingAddress,
        loadingStatus: payload,
      },
    }),
    [setPublisherBillingAddressData]: (state, { payload }) => ({
      ...state,
      billingAddress: {
        ...state.billingAddress,
        data: payload,
      },
    }),
  },
  initialState
);
